export function base64DataUrlToFile(base64DataUrl: string, filename: string) {
    // Split the base64 string into data and contentType
    const [metadata, base64Data] = base64DataUrl.split(",");
    const contentType = metadata.match(/:(.*?);/)![1];

    return base64ToFile(base64Data, filename, contentType);
}

export function base64ToFile(base64String: string, fileName: string, contentType: string) {
    // Decode the base64 string
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Create a Blob from the byte array
    const blob = new Blob([byteArray], { type: contentType });

    // Create a File from the Blob
    const file = new File([blob], fileName, { type: contentType });
    return file;
}
